import API_BASE_URL from './config';
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

// Import background images
import feralBg from './assets/iLVLFeral.png';
import infamousBg from './assets/iLVLInfamous.png';
import notoriousBg from './assets/iLVLNotorious.png';
import disappointingBg from './assets/iLVLDisappointing.png';
import noRankBg from './assets/iLVLRankless.png';
import debutedBg from './assets/iLVLDebuted.png';
import acknowledgedBg from './assets/iLVLAcknowledged.png';
import esteemedBg from './assets/iLVLEsteemed.png';
import cherishedBg from './assets/iLVLCherished.png';
import reveredBg from './assets/iLVLRevered.png';
import keystoneBg from './assets/iLVLKEYSTONE.png';
import exaltedBg from './assets/iLVLExalted.png';
import mythicBg from './assets/iLVLMYTHIC.png';
import cosmicBg from './assets/iLVLCosmic.png';
import timelessBg from './assets/iLVLTimeless.png';

const InteractionLevels = () => {
  const { dogId } = useParams();
  const [dog, setDog] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [scale, setScale] = useState(1);
  const [failedImages, setFailedImages] = useState(new Set());
  const [showControls, setShowControls] = useState(false);
  const [saveMessage, setSaveMessage] = useState(null);
  const [isOwner, setIsOwner] = useState(false);
  const storedPlayerId = localStorage.getItem('playerId');

  const levels = [
    { name: 'Feral', level: -4, ip: -1000, bg: feralBg, requirements: 'None', rewards: 'None' },
    { name: 'Infamous', level: -3, ip: -500, bg: infamousBg, requirements: 'Assigned dog to kennel', rewards: 'Silly item (dog poo bag), DFG$ fine' },
    { name: 'Notorious', level: -2, ip: -250, bg: notoriousBg, requirements: 'Assigned dog to kennel', rewards: 'Silly item (dog poo bag), DFG$ fine' },
    { name: 'Disappointing', level: -1, ip: -100, bg: disappointingBg, requirements: 'Assigned dog to kennel', rewards: 'Silly item (dog poo bag), DFG$ fine' },
    { name: 'No Rank', level: 0, ip: 0, bg: noRankBg, requirements: 'None', rewards: 'None' },
    { name: 'Debuted', level: 1, ip: 10, bg: debutedBg, requirements: 'Assigned dog to kennel', rewards: '50 DFG$, +5% adventure loot chance' },
    { name: 'Acknowledged', level: 2, ip: 100, bg: acknowledgedBg, requirements: '1 adventure completed, 1 ACE animal found', rewards: '50 DFG$, +5% adventure loot chance' },
    { name: 'Esteemed', level: 3, ip: 250, bg: esteemedBg, requirements: '5 adventures completed, 1 ACE collection', rewards: '100 DFG$, 1x box of training tools, +5% adventure boost' },
    { name: 'Cherished', level: 4, ip: 500, bg: cherishedBg, requirements: '20 adventures completed, 2 ACE collections, 1 staff with +100 reputation', rewards: '150 DFG$, 1x box of training tools, +5% adventure boost, IP level boost' },
    { name: 'Revered', level: 5, ip: 900, bg: reveredBg, requirements: '3 titles or 2 ACE collections', rewards: '200 DFG$, +10% adventure loot chance, 1x box of training tools, IP level boost' },
    { name: 'Keystone', level: 6, ip: 1500, bg: keystoneBg, requirements: '1 Advanced/Master title or 3 ACE collections', rewards: '300 DFG$, 1 rare item' },
    { name: 'Exalted', level: 7, ip: 2400, bg: exaltedBg, requirements: '1 Advanced title and 1 ACE collection', rewards: '450 DFG$, +10% show performance' },
    { name: 'Mythic', level: 8, ip: 3500, bg: mythicBg, requirements: '1 Master Level title', rewards: '700 DFG$, 1 legendary shop item (staff emotes)' },
    { name: 'Cosmic', level: 9, ip: 5000, bg: cosmicBg, requirements: '2 Master Level titles or 5 ACE collections', rewards: '1000 DFG$, +15% adventure loot chance' },
    { name: 'Timeless', level: 10, ip: 6500, bg: timelessBg, requirements: '3 Master Level titles or 7 ACE collections', rewards: '1500 DFG$, 1 premium shop item (Starbase background)' },
  ];

  const fallbackBackground = 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/e278b58f-e271-405b-8060-c4679e13d416/djax4s9-e1c34186-a90c-49e1-8342-4599e932dd4e.png/v1/fill/w_894,h_894,q_70,strp/greenpatch_bg_by_dogfanciersguild_djax4s9-pre.jpg';

  useEffect(() => {
    const fetchDogData = async () => {
      console.log(`Fetching dog with dogId: ${dogId}`);
      try {
        setLoading(true);
        const apiUrl = `${API_BASE_URL}/dog/${dogId}`;
        console.log(`API Request URL: ${apiUrl}`);
        const response = await axios.get(apiUrl, {
          headers: { Accept: 'application/json' },
        });
        console.log('API Response:', response.data);
        setDog(response.data);
        setIsOwner(!!response.data.playerId && response.data.playerId === storedPlayerId);
        if (response.data.interactionPosition) {
          setPosition({
            x: response.data.interactionPosition.x || 0,
            y: response.data.interactionPosition.y || 0,
          });
          setScale(response.data.interactionPosition.scale || 1);
        }
        setError(null);
      } catch (err) {
        console.error('Error fetching dog data:', {
          message: err.message,
          status: err.response?.status,
          data: err.response?.data,
          url: err.config?.url,
        });
        setError(
          err.response?.status === 404
            ? `Dog with ID ${dogId} not found`
            : `Error loading dog data: ${err.message}`
        );
      } finally {
        setLoading(false);
      }
    };

    if (dogId) {
      fetchDogData();
    }
  }, [dogId]);

  const handleSave = async () => {
    try {
      const interactionPosition = { x: position.x, y: position.y, scale };
      console.log('Saving interactionPosition:', interactionPosition);
      const response = await axios.patch(`${API_BASE_URL}/dogs/${dogId}`, {
        interactionPosition,
      });
      console.log('Save response:', response.data);
      setSaveMessage('Position and scale saved successfully');
      setTimeout(() => setSaveMessage(null), 3000);
    } catch (err) {
      console.error('Error saving position and scale:', {
        message: err.message,
        status: err.response?.status,
        data: err.response?.data,
      });
      setSaveMessage(`Failed to save: ${err.message}`);
      setTimeout(() => setSaveMessage(null), 5000);
    }
  };

  const getCurrentLevel = (ip) => {
    if (ip === 0) return levels.find((level) => level.level === 0);
    for (let i = levels.length - 1; i >= 0; i--) {
      if (ip >= levels[i].ip) return levels[i];
    }
    return levels[0];
  };

  const handleImageError = (url) => {
    if (!failedImages.has(url)) {
      console.log('Image failed to load:', url);
      setFailedImages((prev) => new Set(prev).add(url));
    }
  };

  const handleScaleChange = (change) => {
    setScale((prev) => Math.min(Math.max(prev + change, 0.5), 2));
  };

 // Progress bar calculations
const minIP = levels[0].ip; // -1000 (Feral)
const maxIP = levels[levels.length - 1].ip; // 6500 (Timeless)
const totalRange = maxIP - minIP; // 7500
const interactionPoints = dog && Number.isInteger(dog.interactionPoints) ? dog.interactionPoints : 0;
if (dog && !Number.isInteger(dog.interactionPoints)) {
  console.warn(`Invalid interactionPoints for dog ${dogId}: ${dog.interactionPoints}. Using 0.`);
}
console.log('Progress bar values:', { interactionPoints, minIP, maxIP }); // Debug log
const currentLevel = getCurrentLevel(interactionPoints);

// Calculate percentages for positive and negative IP
const negativeWidth = interactionPoints < 0 ? (Math.abs(interactionPoints) / Math.abs(minIP)) * 50 : 0;
const positiveWidth = interactionPoints >= 0 ? (interactionPoints / maxIP) * 50 : 0;
console.log('Progress bar widths:', { negativeWidth, positiveWidth }); // Debug log

  if (loading) {
    return (
      <div style={{ maxWidth: '1200px', margin: '0 auto', textAlign: 'center', paddingTop: '60px' }}>
        <p style={{ color: '#333', fontSize: '16px' }}>Loading...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ maxWidth: '1200px', margin: '0 auto', textAlign: 'center', paddingTop: '60px' }}>
        <div
          style={{
            backgroundColor: '#ffcccc',
            padding: '10px',
            marginBottom: '20px',
            borderRadius: '5px',
            color: '#333',
            fontWeight: 'bold',
            textAlign: 'center',
          }}
        >
          {error}
        </div>
      </div>
    );
  }

  if (!dog) {
    return (
      <div style={{ maxWidth: '1200px', margin: '0 auto', textAlign: 'center', paddingTop: '60px' }}>
        <p style={{ color: '#333', fontSize: '16px' }}>No dog data available for ID {dogId}</p>
      </div>
    );
  }

  const backgroundUrl = failedImages.has(currentLevel.bg) ? fallbackBackground : currentLevel.bg;

  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', textAlign: 'center', paddingTop: '60px' }}>
      <h1
        style={{
          color: '#1E88E5',
          fontSize: '1.8em',
          margin: '0 0 10px',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontWeight: 'bold',
        }}
      >
        {dog.registeredName}
      </h1>
      <p>{dog.dogId}</p>

      {saveMessage && (
        <div
          style={{
            backgroundColor: saveMessage.includes('Failed') ? '#ffcccc' : '#ccffcc',
            padding: '10px',
            margin: '10px 0',
            borderRadius: '5px',
            color: '#333',
            fontWeight: 'bold',
          }}
        >
          {saveMessage}
        </div>
      )}

      <div style={{ position: 'relative', marginTop: '20px' }}>
        <div
          style={{
            position: 'relative',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '600px',
            height: '600px',
            border: '1px solid #d9ead3',
            borderRadius: '8px',
            backgroundColor: '#f9f9f9',
            boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {failedImages.has(backgroundUrl) ? (
            <div
              style={{
                position: 'absolute',
                inset: '0',
                backgroundColor: '#ccc',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'black',
                zIndex: '10',
              }}
            >
              Background Unavailable
            </div>
          ) : (
            <img
              src={backgroundUrl}
              alt={`${currentLevel.name} background`}
              style={{
                position: 'absolute',
                maxWidth: '600px',
                maxHeight: '600px',
                objectFit: 'contain',
                objectPosition: 'center',
                zIndex: 0,
              }}
              onError={() => handleImageError(currentLevel.bg)}
            />
          )}
          {dog.artUrl && !failedImages.has(dog.artUrl) ? (
            <img
              src={dog.artUrl}
              alt={dog.registeredName}
              style={{
                position: 'absolute',
                width: '192px',
                zIndex: 20,
                left: '50%',
                top: '50%',
                transform: `translate(-50%, -50%) translate(${position.x}px, ${position.y}px) scale(${scale})`,
                transformOrigin: 'center',
              }}
              onError={() => handleImageError(dog.artUrl)}
            />
          ) : (
            <div
              style={{
                position: 'absolute',
                width: '192px',
                height: '192px',
                backgroundColor: '#ccc',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'black',
                zIndex: 20,
                borderRadius: '5px',
                left: '50%',
                top: '50%',
                transform: `translate(-50%, -50%) translate(${position.x}px, ${position.y}px) scale(${scale})`,
                transformOrigin: 'center',
              }}
            >
              No Image
            </div>
          )}
        </div>
      </div>

      <div style={{ marginTop: '20px' }}>
        {/* Only show the button and controls if the player owns the dog */}
        {isOwner && (
          <button
            onClick={() => setShowControls(!showControls)}
            style={{
              padding: '5px 10px',
              backgroundColor: '#4CAF50',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '12px',
            }}
            onMouseOver={(e) => (e.target.style.opacity = '0.9')}
            onMouseOut={(e) => (e.target.style.opacity = '1')}
          >
            {showControls ? 'Hide Controls' : 'Manage Display'}
          </button>
        )}

        {showControls && isOwner && (
          <div style={{ marginTop: '10px', display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '10px' }}>
            <button
              onClick={() => setPosition((prev) => ({ ...prev, x: prev.x - 10 }))}
              style={{
                padding: '5px 10px',
                backgroundColor: '#4CAF50',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '12px',
              }}
              onMouseOver={(e) => (e.target.style.opacity = '0.9')}
              onMouseOut={(e) => (e.target.style.opacity = '1')}
            >
              Left
            </button>
            <button
              onClick={() => setPosition((prev) => ({ ...prev, x: prev.x + 10 }))}
              style={{
                padding: '5px 10px',
                backgroundColor: '#4CAF50',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '12px',
              }}
              onMouseOver={(e) => (e.target.style.opacity = '0.9')}
              onMouseOut={(e) => (e.target.style.opacity = '1')}
            >
              Right
            </button>
            <button
              onClick={() => setPosition((prev) => ({ ...prev, y: prev.y - 10 }))}
              style={{
                padding: '5px 10px',
                backgroundColor: '#4CAF50',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '12px',
              }}
              onMouseOver={(e) => (e.target.style.opacity = '0.9')}
              onMouseOut={(e) => (e.target.style.opacity = '1')}
            >
              Up
            </button>
            <button
              onClick={() => setPosition((prev) => ({ ...prev, y: prev.y + 10 }))}
              style={{
                padding: '5px 10px',
                backgroundColor: '#4CAF50',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '12px',
              }}
              onMouseOver={(e) => (e.target.style.opacity = '0.9')}
              onMouseOut={(e) => (e.target.style.opacity = '1')}
            >
              Down
            </button>
            <button
              onClick={() => handleScaleChange(0.1)}
              style={{
                padding: '5px 10px',
                backgroundColor: '#4CAF50',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '12px',
              }}
              onMouseOver={(e) => (e.target.style.opacity = '0.9')}
              onMouseOut={(e) => (e.target.style.opacity = '1')}
            >
              Bigger
            </button>
            <button
              onClick={() => handleScaleChange(-0.1)}
              style={{
                padding: '5px 10px',
                backgroundColor: '#4CAF50',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '12px',
              }}
              onMouseOver={(e) => (e.target.style.opacity = '0.9')}
              onMouseOut={(e) => (e.target.style.opacity = '1')}
            >
              Smaller
            </button>
            <button
              onClick={handleSave}
              style={{
                padding: '5px 10px',
                backgroundColor: '#1E88E5',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '12px',
              }}
              onMouseOver={(e) => (e.target.style.opacity = '0.9')}
              onMouseOut={(e) => (e.target.style.opacity = '1')}
            >
              Save
            </button>
          </div>
        )}
      </div>

      <div style={{ marginTop: '40px' }}>
        <h2 style={{ color: '#0b5394', marginBottom: '20px', fontSize: '1.5em' }}>Interaction Points</h2>
        <div
          style={{
            backgroundColor: '#f9f9f9',
            padding: '20px',
            borderRadius: '8px',
            border: '1px solid #d9ead3',
            boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
            maxWidth: '600px',
            margin: '0 auto',
          }}
        >
          <div style={{ marginBottom: '10px', color: '#333' }}>
            <p style={{ fontWeight: 'bold', color: '#4CAF50' }}>
              Points: {interactionPoints}
            </p>
            <p style={{ fontWeight: 'bold', color: '#4CAF50' }}>
              Level: {currentLevel.name} (Level {currentLevel.level})
            </p>
          </div>
          <div
            style={{
              display: 'flex',
              width: '100%',
              height: '20px',
              backgroundColor: '#e0e0e0',
              borderRadius: '10px',
              overflow: 'hidden',
              position: 'relative',
            }}
          >
            <div
              style={{
                width: `${negativeWidth}%`,
                backgroundColor: '#ff4d4d',
                position: 'absolute',
                right: '50%',
                height: '100%',
                transition: 'width 0.3s ease-in-out',
              }}
            />
            <div
              style={{
                width: `${positiveWidth}%`,
                backgroundColor: '#4CAF50',
                position: 'absolute',
                left: '50%',
                height: '100%',
                transition: 'width 0.3s ease-in-out',
              }}
            />
            <div
              style={{
                position: 'absolute',
                left: '50%',
                transform: 'translateX(-50%)',
                width: '2px',
                height: '100%',
                backgroundColor: '#333',
              }}
            />
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: '5px',
              fontSize: '12px',
              color: '#666',
            }}
          >
            <span>{minIP} (Feral)</span>
            <span>0 (No Rank)</span>
            <span>{maxIP} (Timeless)</span>
          </div>
          <p style={{ marginTop: '10px' }}>
            <a
              href="/levels"
              style={{ color: '#4CAF50', textDecoration: 'none' }}
              onMouseOver={(e) => (e.target.style.textDecoration = 'underline')}
              onMouseOut={(e) => (e.target.style.textDecoration = 'none')}
            >
              View all levels
            </a>
          </p>
        </div>
      </div>
      <div style={{ marginTop: '40px' }}>
  <h2 style={{ color: '#0b5394', marginBottom: '20px', fontSize: '1.5em' }}>Health Points</h2>
  <div
    style={{
      backgroundColor: '#f9f9f9',
      padding: '20px',
      borderRadius: '8px',
      border: '1px solid #d9ead3',
      boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
      maxWidth: '600px',
      margin: '0 auto',
    }}
  >
    <div style={{ marginBottom: '10px', color: '#333' }}>
      <p style={{ fontWeight: 'bold', color: '#4CAF50' }}>
        Health: {dog?.healthPoints ?? 100} / 100
      </p>
      {dog?.status === 'Hospitalized' && (
        <p style={{ color: '#ff4d4d', fontWeight: 'bold' }}>
          This dog is Hospitalized and cannot be played until healed!
        </p>
      )}
    </div>
    <div
      style={{
        width: '100%',
        height: '20px',
        backgroundColor: '#e0e0e0',
        borderRadius: '10px',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <div
        style={{
          width: `${((dog?.healthPoints ?? 100) / 100) * 100}%`,
          backgroundColor: '#4CAF50',
          height: '100%',
          transition: 'width 0.3s ease-in-out',
        }}
      />
    </div>
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: '5px',
        fontSize: '12px',
        color: '#666',
      }}
    >
      <span>0</span>
      <span>100</span>
    </div>
  </div>
</div>
    </div>
  );
};

export default InteractionLevels;